import { useState, useRef, useEffect } from "react";
import { send_signup_otp, verify_otp } from "../api/serverWrapper";

const OTP_RESEND_SECONDS = 60;

const VerifyEmailOtp = ({ email, onVerified }) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(OTP_RESEND_SECONDS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const inputsRef = useRef([]);

  // ================= AUTO FOCUS FIRST =================

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  // ================= TIMER =================

  useEffect(() => {
    if (timer === 0) return;

    const interval = setInterval(() => {
      setTimer((t) => t - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  // ================= INPUT =================

  // ================= INPUT CHANGE =================

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move forward only if value entered
    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      // If current box has value → clear it
      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // If empty → go back and clear previous
        inputsRef.current[index - 1].focus();

        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    const pasteData = e.clipboardData.getData("text").trim();

    if (!/^\d+$/.test(pasteData)) return;

    const pasteArray = pasteData.slice(0, 6).split("");

    const newOtp = [...otp];

    pasteArray.forEach((val, i) => {
      newOtp[i] = val;
    });

    setOtp(newOtp);

    // Focus last filled box
    const lastIndex = pasteArray.length - 1;
    inputsRef.current[lastIndex]?.focus();
  };

  // ================= VERIFY =================

  const handleVerify = async () => {
    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      setError("Enter complete OTP");
      return;
    }

    setLoading(true);
    setError("");

    try {
      let data = {
        Email: email,
        Otp: finalOtp,
      };

      //    onVerified();

      let res = await verify_otp(data);

      if (res.success) {
        onVerified();
      } else {
        setError(res.message);
      }
    } catch {
      setError("Verification failed");
    } finally {
      setLoading(false);
    }
  };

  // ================= RESEND =================

  const resendOtp = async () => {
    if (timer !== 0) return;
    let res = await send_signup_otp({ Email: email });
    setTimer(OTP_RESEND_SECONDS);
  };

  return (
    <div className="email-card">
      <h2>OTP Verification</h2>

      <div className="otp-boxes">
        {otp.map((digit, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            className="otp-input"
            value={digit}
            ref={(el) => (inputsRef.current[index] = el)}
            onChange={(e) => handleInputChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={handlePaste}
          />
        ))}
      </div>

      {error && <small className="error-text">{error}</small>}

      <button
        className="otp-verify-btn"
        onClick={handleVerify}
        disabled={loading}
      >
        {loading ? "Verifying..." : "Verify →"}
      </button>

      <p
        className="resend-text"
        onClick={resendOtp}
        style={{ cursor: timer === 0 ? "pointer" : "default" }}
      >
        {timer === 0
          ? "Resend OTP"
          : `Resend in ${Math.floor(timer / 60)
              .toString()
              .padStart(2, "0")}:${(timer % 60).toString().padStart(2, "0")}`}
      </p>
    </div>
  );
};

export default VerifyEmailOtp;
